import * as React from 'react';
import { Link } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import styled from 'styled-components';
import warningPng from '../../../images/warning.png';
import FieldDecorator from '../../../commonComponents/fields/FieldDecorator';
import { recaptchaSiteKey } from '../../../config.local';
import { UserLoginAttemptsDetails } from '../../../models/be/transport/UserLoginAttemptsDetails';
import Checkbox from '../../common/fields/Checkbox';
import { hasValue } from '../../../lib/utils';

export default (props: Props) => {
	const handleKeyPress = (e: React.KeyboardEvent<unknown>) => {
		if (e.key === 'Enter') props.onSubmit();
	};
	const handleEmailFieldKeyPress = (e: React.KeyboardEvent<unknown>) => {
		if (e.key === 'Enter') props.onNext();
	};

	return (
		<div className="loginForm">
			<label>Email</label>
			<input
				className="input"
				id="email"
				type="text"
				name="Username"
				value={props.username}
				onChange={props.onUsernameChange}
				onKeyPress={handleEmailFieldKeyPress}
				autoCapitalize="off"
				required
			/>
			{props.showPassword && (
				<>
					<label>Password</label>
					<input
						title="password"
						className="input"
						id="password"
						type="password"
						name="Password"
						value={props.password}
						onChange={props.onPasswordChange}
						onKeyPress={handleKeyPress}
					/>
					{props.userLoginAttempts.invalidLoginCount > 2 && (
						<FieldDecorator className="recaptcha">
							<ReCAPTCHA sitekey={recaptchaSiteKey} onChange={props.handleRecaptchaChange} ref={props.recaptchaRef} />
						</FieldDecorator>
					)}
					{props.errorMessage && (
						<div className="errorMessage">
							<img src={warningPng} width="16" height="13" alt="Warning Icon" />
							<p>{props.errorMessage}</p>
						</div>
					)}
				</>
			)}
			<RememberedContainer>
				<Checkbox
					name="remembered"
					label="Remember me"
					className=""
					value={props.remembered}
					onValueChange={(key: string, value: boolean) => {
						props.onRememberedChange(value);
					}}
				/>
			</RememberedContainer>
			{props.showPassword ? (
				<>
					<button
						type="button"
						id="loginButton"
						className="primaryBtn"
						onClick={props.onSubmit}
						onKeyPress={handleKeyPress}
					>
						{props.buttonText}
					</button>
					{/* <Link to={{ pathname: '/register' }} id="registerLink" className="loginLink">
				Register
			</Link>  Removed Register button temporarily */}
					<Link
						to={{
							pathname: '/forgot-password',
							search: hasValue(props.username) ? `?email=${encodeURIComponent(props.username)}` : ''
						}}
						id="forgotPasswordLink"
						className="loginLink"
					>
						Forgot Password?
					</Link>
				</>
			) : (
				<>
					{props.errorMessage && !hasValue(props.username) && (
						<ErrorMessageWrapper>
							<img src={warningPng} width="16" height="13" alt="Warning Icon" />
							<p>{props.errorMessage}</p>
						</ErrorMessageWrapper>
					)}
					<button
						type="button"
						id="nextButton"
						className="primaryBtn"
						onClick={props.onNext}
						onKeyPress={handleKeyPress}
					>
						Next
					</button>
				</>
			)}
		</div>
	);
};

interface Props {
	username: string;
	password: string;
	remembered: boolean;
	showPassword: boolean;
	buttonText: string;
	onUsernameChange(e: React.ChangeEvent<HTMLInputElement>): void;
	onPasswordChange(e: React.ChangeEvent<HTMLInputElement>): void;
	onRememberedChange(value: boolean): void;
	onSubmit(): void;
	onNext(): void;
	errorMessage: string;
	handleRecaptchaChange(value: string): void;
	recaptchaRef: React.LegacyRef<ReCAPTCHA>;
	userLoginAttempts: UserLoginAttemptsDetails;
}

const RememberedContainer = styled.div`
	 {
		margin-top: 10px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		margin-bottom: 0px !important;
		div {
			margin-bottom: 0px !important;
		}
		input.k-checkbox {
			width: 15px !important;
			height: 15px !important;
			border-radius: 2px !important;
			padding-top: 5px !important;
			margin-left: 10px !important;
			border-color: #c3cad4;
			background-color: #ffffff;
		}
		.k-checkbox:checked,
		.k-checkbox:checked + .k-checkbox-label::before {
			background-color: #1589ee;
			border-color: #1589ee;
			box-shadow: 0 0 0 2px rgba(21, 137, 238, 0.3);
		}
		label {
			margin-left: 10px !important;
			display: inline !important;
		}
	}
`;

const ErrorMessageWrapper = styled.div.attrs({
	className: 'errorMessage'
})`
	 {
		margin: 10px 0px 0px 30px;
	}
`;
